import { render, staticRenderFns } from "./AlternativeDepartureItem.vue?vue&type=template&id=dbe77bc2&lang=pug&"
import script from "./AlternativeDepartureItem.vue?vue&type=script&langs=ts&lang=js&"
export * from "./AlternativeDepartureItem.vue?vue&type=script&langs=ts&lang=js&"
import style0 from "./AlternativeDepartureItem.vue?vue&type=style&index=0&id=dbe77bc2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports